<template>
  <div>
    <Modal class="my-modal mer-detail-modal" v-model="visible" :title="'详情'" width="800" :footer-hide="true">
      <Form class="detail-form" :model="formData" inline :label-width="100">
        <FormItem label="转介人名称">{{ detail.merchantName }}</FormItem>
        <!-- <FormItem v-if="detail.parentName" label="上级转介人">{{ detail.parentName }}</FormItem> -->
        <FormItem label="联系人">{{ detail.contact }}</FormItem>
        <FormItem label="联系电话">
          <span class="item-value" v-if="detail.eyeShow_mobile">{{ detail.mobile }}</span>
          <span class="item-value" v-else>{{ detail.mobile1 }}</span>
          <template v-if="detail.mobile1">
            <!-- <i class="iconfont iconxianshi eye-icon eye" v-if="detail.eyeShow_mobile" @click="openEye(detail, 'mobile')"></i> -->
            <i class="iconfont iconyincang eye-icon eye" v-if="!detail.eyeShow_mobile" @click="openEye(detail, 'mobile')"></i>
          </template>
        </FormItem>
        <FormItem label="转介人状态">{{ detail.status == '1' ? '启用' : '禁用' }}</FormItem>
        <FormItem label="省份">{{ detail.province }}</FormItem>
        <FormItem label="城市">{{ detail.city }}</FormItem>
        <FormItem label="详细地址">
          <span class="item-value" v-if="detail.eyeShow_address">{{ detail.address }}</span>
          <span class="item-value" v-else>{{ detail.address1 }}</span>
          <template v-if="detail.address1">
            <!-- <i class="iconfont iconxianshi eye-icon eye" v-if="detail.eyeShow_address" @click="openEye(detail, 'address')"></i> -->
            <i class="iconfont iconyincang eye-icon eye" v-if="!detail.eyeShow_address" @click="openEye(detail, 'address')"></i>
          </template>
        </FormItem>
        <FormItem label="用户等级" prop="vipLevel">
          <!-- 顶级的直属转介人且父级有等级时才显示 -->
          <Select v-if="curTreeData.parentId === parent.currAccountId && curTreeData.parentVipLevel" v-model="formData.vipLevel" clearable transfer>
            <Option v-for="item in vipLevelList" :value="item.value" :key="item.value" :disabled="item.disabled">{{ item.label }}</Option>
          </Select>
          <!-- <lzDicTxt v-else dicType="VIP_LEVEL" :dicCode="formData.vipLevel" /> -->
          <div v-else>{{ parent.getFakeVipLevelText(formData.vipLevel) }}</div>
        </FormItem>
      </Form>
      <div
        v-if="curTreeData.id && !curTreeData.isTop && curTreeData.parentId === parent.currAccountId && curTreeData.parentVipLevel"
        class="form-btn-bar"
        style="text-align:center;padding-top: 60px"
      >
        <Button type="primary" style="width:150px" @click="handleSaveForm">保存</Button>
      </div>
    </Modal>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';
import validUserName from '@/components/commons/validUserName';

const dic = JSON.parse(localStorage.dic);

const VIP_LEVEL = dic['VIP_LEVEL'];

let base_vipLevelList = [];
for (let key in VIP_LEVEL) {
  base_vipLevelList.push({
    value: key,
    label: VIP_LEVEL[key]
  });
}
base_vipLevelList.sort((a, b) => a.value - b.value);

export default {
  mixins: [pageTool, common],
  inject: ['parent'],
  components: { lzDicTxt, validUserName },
  data() {
    return {
      visible: false,
      title: '',
      currentRow: {},
      isShowPassword: false,
      isShowUserType: false,
      isShowMobile: false,
      isShowMobile1: false,
      isShowEye: false,
      isShowEye1: false,
      isShowEye2: false,
      isShowEye3: false,
      curTreeData: {},
      detail: {},
      formData: {}
    };
  },
  computed: {
    vipLevelList() {
      // vip等级从大到小 large=1 small=15
      if (this.curTreeData.parentVipLevel) {
        const large = Number(this.curTreeData.parentVipLevel);
        return base_vipLevelList.filter(item => Number(item.value) >= large);
      } else {
        return JSON.parse(JSON.stringify(base_vipLevelList));
      }
    }
  },
  methods: {
    open(item, successCB) {
      this.successCB = successCB;
      this.curTreeData = JSON.parse(JSON.stringify(item));
      this.getDetailData(item);
    },
    getDetailData(item) {
      const params = {
        url: '',
        // type: 'POST',
        data: {
          id: item.id
        }
      };
      if (item.nodeType * 1 === 0) {
        // 转介人
        params.url = '/buz/merchant/curr/detail';
        params.type = 'POST';
      } else {
        // 团队
        params.url = '/buz/groupBase/read/detail';
        params.type = 'GET';
      }

      return this.$http(params).then(res => {
        res.data.childNum = res.data.childNum || 0;
        res.data.agentNum = res.data.agentNum || 0;

        res.data.address1 = res.data.address;
        res.data.vipLevel = (res.data.vipLevel || '') + '';
        // this.curTreeData.vipLevel = res.data.vipLevel;
        this.detail = res.data;
        this.detail.supervise = res.data.supervise ? res.data.supervise : '1';
        this.formData.vipLevel = res.data.vipLevel;
        this.visible = true;
      });
    },
    handleSaveForm() {
      // if (Number(this.formData.vipLevel) >= Number(this.curTreeData.parentVipLevel)) {
      //   this.$notice.error('用户等级只能取比上级转介人更低的级别');
      //   return;
      // }
      this.$http({
        url: '/buz/merchant/edit',
        type: 'GET',
        data: {
          tenantId: this.curTreeData.id,
          vipLevel: this.formData.vipLevel
        }
      })
        .then(res => {
          this.$notice.success('操作成功');
          this.successCB && this.successCB(0);
          this.visible = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    // 解密
    openEye(row, type) {
      if (!row['validName' + type]) {
        this.$refs.validUserNameRef.open(row, type);
        return;
      }
      /**
       * operationFunction
       * 1-业务员详情
       * 2-转介人详情
       * 3-保单详情
       * 4-变更记录旧值
       * 5-变更记录新值
       * 6.客户详情解密
       * 7-客户导出解密
       * 8-注册用户信息
       * 9-保单变更记录解密
       * 11-运营后台账户解密
       * 12-内勤人员详情
       * 13-转介人活动解密
       * 14-预约管理解密
       * 15-转介人提现记录解密
       * 16-三要素验证解密
       * 17-周边服务订单
       * 18-结算
       * 19-建议书
       */
      /**
       * operationType
       * 1-证件号解密
       * 2-手机号解密
       * 3-银行卡号
       * 4-邮箱
       * 5-通讯地址
       * 6.身份证地址
       * 7-居住地地址
       * 8-通行证/护照号码
       * 9-公司/学校名称
       * 10-公司/学校地址
       * 11-保单号解密
       * 12-姓名
       * 13-姓名拼音
       * 14图片附件
       */
      /**
       * source;
       * 1、运营后台
       * 2、转介人后台
       * 3、小程序
       */
      /**
       * cardType
       * idcard_head 身份证头像面
       * idcard_back 身份证国微面
       * passport_head 港澳通行证、护照头像面
       * passport_back 港澳通行证反面
       * payment 缴费凭证
       * account  账户证明
       * pay_notice_pdf  续费通知书
       */
      /**
       * customerType
       * 1-投保人
       * 2-受保人
       * 3-受益人
       * 4-保单第二持有人
       * 99其他
       */
      /**
       * index
       * 用户类型为受益人时，数组下标
       */
      if (!type) {
        if (!row.eyeShow) {
          this.descrypt(
            {
              query: row.id,
              operationFunction: 1,
              operationType: 2
            },
            row,
            'mobile'
          ).then(() => {
            this.$set(row, 'eyeShow', true);
          });
        } else {
          this.$set(row, 'eyeShow', false);
        }
      } else if (type == 'mobile') {
        const ryrKey = `eyeShow_${type}`;
        if (!row[ryrKey]) {
          this.descrypt(
            {
              query: row.id,
              operationFunction: 2,
              operationType: 2 // 手机号
            },
            row,
            type
          ).then(() => {
            this.$set(row, ryrKey, true);
          });
        } else {
          this.$set(row, ryrKey, false);
        }
      } else if (type == 'address') {
        const ryrKey = `eyeShow_${type}`;
        if (!row[ryrKey]) {
          this.descrypt(
            {
              query: row.id,
              operationFunction: 2,
              operationType: 5 // 通讯地址
            },
            row,
            type
          ).then(() => {
            this.$set(row, ryrKey, true);
          });
        } else {
          this.$set(row, ryrKey, false);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mer-detail-modal {
  /deep/.ivu-modal-body {
    padding-top: 10px;
    padding-bottom: 20px;
  }
  .detail-form {
    /deep/ .ivu-form-item {
      width: 33.33%;
      margin-right: 0;
    }
  }
}
</style>
